import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Header.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobLink: {},
    };
  }

  // TODO: change to non-deprecated method
  UNSAFE_componentWillReceiveProps(props) { // eslint-disable-line camelcase
    const { review: { links } } = props;
    if (links && links.job_details) {
      const { jobLink } = this.state;
      const { label, href } = links.job_details;
      this.setState({
        jobLink: {
          ...jobLink,
          text: label,
          location: href,
          data: 'JobDetails',
        },
      });
    }
  }

  render() {
    const {
      review: { translator_id: translatorId, links, meta: metaProps },
      score,
    } = this.props;
    const { jobLink: { data, location, text } } = this.state;
    const meta = metaProps || {};
    return (
      <>
        <div className="navbar navbar-inverse flex-row header">
          <div className="header-left">
            <span href="/" className="brand icon-worker">
              <i className="icon-lionbridge" />
            </span>
            {links
            && (
            <h1 className="gengo-navigation">
              <a target="_blank" rel="noopener noreferrer" data={data} href={location}>
                {text}
              </a>
              {' '}
              |
              {' '}
              Translator ID:
              {translatorId}
            </h1>
            )}
          </div>
          <div className="header-right">
            <div className="word-count">
              GoCheck:
              {' '}
              <span className="real-time-score">
                { score || <div className="loader-small" /> }
              </span>
              {' '}
              |
              {' '}
              Word count:
              {' '}
              {meta.src_unit_count}
            </div>
          </div>
        </div>
        <div className="sub-header">
          <header className="src-header">
            <h2>
              Original :
              {meta.lc_src}
              {' '}
            </h2>
          </header>
          <header className="tgt-header">
            <h2>
              Target :
              {meta.lc_tgt}
            </h2>
          </header>
        </div>
      </>
    );
  }
}

Header.propTypes = {
  review: PropTypes.object.isRequired,
  score: PropTypes.number,
};

Header.defaultProps = {
  score: null,
};

export default Header;
